import type {ClientDiffLine, FileDiffReference} from '../../types'
import type {DiffAnnotation, Thread, ViewerData} from '../../conversation-types'
import type {HunkData} from '../../helpers/hunk-data-helpers'
import type {DiffAnchor} from '@github-ui/diffs/types'
import {SimpleAddCommentButton} from './SimpleAddCommentButton'
import {SimpleContextMenu} from './SimpleContextMenu'

/**
 * The ActionBar is a set of buttons that appears on hover or focus of a cell in the diff grid.
 * The buttons will be absolutely positioned to the right side of the diff cell.
 */
type ActionBarProps = {
  annotations: DiffAnnotation[]
  authorLogin: string
  authorAvatarUrl: string
  copilotChatReference?: FileDiffReference
  currentHunk: HunkData | undefined
  diffAnchor: DiffAnchor
  diffLine: ClientDiffLine
  handleCopyCode?: () => void
  hasDraftComment?: boolean
  isLeftSide: boolean
  isSplit: boolean
  nextHunk: HunkData | undefined
  previousHunk: HunkData | undefined
  shouldDisplayCollapseComments?: boolean
  shouldDisplayMinimizedComments?: boolean
  showStartConversation: boolean
  threads: Thread[]
  toggleViewingMarkers: () => void
  viewerData: ViewerData
  openStartConversationDialog: () => void
  ref?: React.Ref<HTMLTableCellElement>
}

export function SimpleActionBar({
  ref: _dialogReturnFocusRef,
  annotations,
  authorAvatarUrl,
  authorLogin,
  copilotChatReference,
  currentHunk,
  diffAnchor,
  diffLine,
  hasDraftComment,
  handleCopyCode,
  isLeftSide,
  isSplit,
  nextHunk,
  previousHunk,
  shouldDisplayCollapseComments,
  shouldDisplayMinimizedComments,
  showStartConversation,
  threads,
  toggleViewingMarkers,
  viewerData,
  openStartConversationDialog,
}: ActionBarProps) {
  return (
    <>
      <SimpleAddCommentButton
        showStartConversation={showStartConversation}
        hasDraftComment={hasDraftComment}
        lineSpacingPreference={viewerData.lineSpacingPreference}
        openStartConversationDialog={openStartConversationDialog}
        authorLogin={authorLogin}
        authorAvatarUrl={authorAvatarUrl}
      />
      <SimpleContextMenu
        showStartConversation={showStartConversation}
        viewerData={viewerData}
        openStartConversationDialog={openStartConversationDialog}
        threads={threads}
        annotations={annotations}
        shouldDisplayMinimizedComments={shouldDisplayMinimizedComments ?? false}
        diffAnchor={diffAnchor}
        diffLine={diffLine}
        isLeftSide={isLeftSide}
        isSplit={isSplit}
        nextHunk={nextHunk}
        previousHunk={previousHunk}
        currentHunk={currentHunk}
        copilotChatReference={copilotChatReference}
        handleCopyCode={handleCopyCode}
        shouldDisplayCollapseComments={shouldDisplayCollapseComments}
        toggleViewingMarkers={toggleViewingMarkers}
      />
    </>
  )
}

SimpleActionBar.displayName = 'ActionBar'
